import { render, staticRenderFns } from "./tabBatch.vue?vue&type=template&id=69533bed&scoped=true"
import script from "./tabBatch.vue?vue&type=script&lang=js"
export * from "./tabBatch.vue?vue&type=script&lang=js"
import style0 from "./tabBatch.vue?vue&type=style&index=0&id=69533bed&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69533bed",
  null
  
)

export default component.exports